import React, { useState, useEffect } from "react";
import Meta from "../../components/Meta";
import Image from "next/image";
import ContactForm from "../../components/contact/ContactForm";
import Link from "next/link";
import YourGatewayToMakeDifference from "../../components/homepage_redesign/yourGatewayToMakeDifference";
import Address from "../../components/contact/address";


import { with_our_partner } from "../../data/team_data";

const WorldOfImpact = () => {
  const [video, setVideo] = useState(false);
  const [partyTime, setPartyTime] = useState(false);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const target = new Date("07/21/2024 23:59:59");

    const interval = setInterval(() => {
      const now = new Date();
      const difference = target.getTime() - now.getTime();

      const d = Math.floor(difference / (1000 * 60 * 60 * 24));
      setDays(d);

      const h = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      setHours(h);

      const m = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      setMinutes(m);

      const s = Math.floor((difference % (1000 * 60)) / 1000);
      setSeconds(s);

      if (d <= 0 && h <= 0 && m <= 0 && s <= 0) {
        setPartyTime(true);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Meta title="Partners || Impactoverse" />
      {/* <!-- Page title --> */}
      <section className="relative pt-24 lg:pb-10">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
          <Image
            width={1519}
            height={773}
            priority
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="lg:flex lg:space-x-12">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={935}
              src="/images/gradient.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
            <Image
              width={1519}
              height={935}
              src="/images/gradient_dark.jpg"
              alt="gradient dark"
              className="h-full w-full object-cover"
            />
          </picture>
        </div>
        <div className="container mx-auto text-center">
          <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
            Our
            <span className="animate-gradient"> Partners</span>
          </h1>
 <div
                    className={`relative p-5 rounded-2.5xl border border-jacarta-100 bg-white transition-shadow hover:shadow-xl dark:border-jacarta-50 dark:bg-jacarta-700 my-10 `}
                  >
                    <h3 className="font-display text-2xl text-jacarta-700 dark:text-white lg:text-3xl xl:text-4xl text-center uppercase mb-4">
                      THE HARMONY PROJECT
                    </h3>
                    <h3 className="block font-display text-xl font-medium group-hover:text-accent dark:text-white text-center">
                      Work on nature-based curriculum aligned programmes.
                      Learning from nature, not just about nature. Transforming
                      education and integrating solutions to meet the challenges
                      that face the next generation.
                    </h3>
                    <div className="flex items-center justify-center mt-4"></div>
                    {/* <p className="dark:text-jacarta-300">{item.text}</p> */}
                  </div>
            <div className="lg:flex lg:space-x-12">
              <div className="mb-12 lg:w-full"></div>
            </div>
            <div className="lg:flex lg:space-x-12">
              <div className="mb-12">
                <div className="rounded-2.5xl ">
                  <h3 className="font-display text-xl text-jacarta-700 dark:text-white lg:text-2xl xl:text-3xl text-center uppercase mb-4">
                    WE WORK WITH EXPERTS TO OFFER CURRICULUM-ALIGNED
                    SUSTAINABILITY RESOURCES FOR PARENTS, STUDENTS AND
                    EDUCATORS!
                  </h3>

                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-[1.875rem] lg:grid-cols-5 mb-12">
                    {with_our_partner.map((item) => {
                      const { id, image, title } = item;
                      return (
                        <div
                          className="flex flex-col items-center justify-center"
                          key={id}
                        >
                          <div
                            className="relative rounded-2.5xl mb-6 h-[9.125rem] w-[9.125rem] bg-cover"
                            style={{ backgroundImage: `url(${image})` }}
                          >
                          </div>
                          <div className="rounded-2.5xl flex items-center justify-center w-[9.125rem] h-28">
                            <span className="dark:text-jacarta-300 text-md text-center font-semibold">
                              {title}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                 

                  {/* <Link
                  href="https://artforimpact.club"
                  target="_blank"
                  className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark "
                >
                  FIND OUT MORE
                </Link> */}
                </div>

                {/* <div className="rounded-2.5xl bg-white p-12 dark:bg-jacarta-700">
              <span className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                WORLD OF IMPACT
              </span>
              <p className="mb-8 text-lg dark:text-jacarta-300">
                Dive into a world of amazing experiences, games, innovations and
                opportunities for impact that rewards you!
              </p>
              <a
                href="/world-of-impact"
                target="_blank"
                className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
              >
                Find Out More
              </a>
            </div> */}
              </div>
            </div>
        </div>
      </section>

      <YourGatewayToMakeDifference />
      {/* <!-- Intro / Statistics --> */}

      {/* <div className="container py-10">
        <div className="relative overflow-hidden rounded-2.5xl px-16 pt-16 pb-8 shadow-md lg:px-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_dark.jpg"
              alt="gradient dark"
              className="h-full w-full object-cover"
            />
          </picture>
          <div className="md:flex">
            <div className="mb-6 md:w-full">
              <h2 className="font-display text-5xl text-jacarta-700 dark:text-white lg:text-6xl xl:text-7xl uppercase text-center">
                <span className="animate-gradient">Launching</span> In
              </h2>

              <div className="js-countdown-single-timer mt-3 flex justify-between">
                <span className="countdown-days text-jacarta-700 dark:text-white">
                  <span className="js-countdown-days-number font-display text-4xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase ">
                    {days}
                  </span>
                  <span className="block text-2xl font-medium tracking-tight">
                    Days
                  </span>
                </span>

                <span className="countdown-hours text-jacarta-700 dark:text-white">
                  <span className="js-countdown-hours-numberm font-display text-4xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase ">
                    {hours}
                  </span>
                  <span className="block text-2xl font-medium tracking-tight">
                    Hrs
                  </span>
                </span>
                <span className="countdown-minutes text-jacarta-700 dark:text-white">
                  <span className="js-countdown-minutes-number font-display text-4xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase ">
                    {minutes}
                  </span>
                  <span className="block text-2xl font-medium tracking-tight">
                    Min
                  </span>
                </span>
                <span className="countdown-seconds text-jacarta-700 dark:text-white">
                  <span className="js-countdown-seconds-number font-display text-4xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase ">
                    {seconds}
                  </span>
                  <span className="block text-2xl font-medium tracking-tight">
                    Sec
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="py-10 dark:bg-jacarta-800 bg-light-base">
        <div className="container">
          <div className="lg:flex">
            <div className="lg:w-1/3 lg:pr-5">
              <div className="dark:bg-jacarta-700 mb-6 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl border bg-white p-10">
                <div className="mb-6 flex items-center space-x-5">
                  <h3 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                    Contact Us
                  </h3>
                </div>
                <p className="dark:text-jacarta-300 mb-6 text-lg leading-normal">
                  {
                    "If you’d like to showcase your brand, cause, project, product, or service, get in touch to let us know what it is, and how it aligns with impact."
                  }
                </p>
              </div>
            </div>
            <div className="mb-12 lg:mb-0 lg:w-2/3 lg:pl-12">
              <ContactForm />
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default WorldOfImpact;
